import { IManInf } from "interface/member";
import { useEffect, useRef } from "react";
import useUserStore from "store/user";
import { useManagerDetailContext } from "./context";
import { useMutation } from "@tanstack/react-query";
import { manInfApi, manInfModifyApi } from "components/api/member";
import useAlertStore from "store/alert";
import { apifield } from "components/utils/comm";

// 매니저 상세
export const useGetData = () => {
  const user = useUserStore((state) => state.user);
  const manInfRef = useRef<IManInf | null>(null);
  const { isSuccess, setIsSuccess } = useManagerDetailContext();

  const mutation = useMutation({
    mutationKey: ["member-manager-detail"],
    mutationFn: manInfApi,
    onSuccess(res) {
      if (res) {
        const {
          status: { code, message },
        } = res;
        if (code === 0) {
          manInfRef.current = res.data;
          setIsSuccess(false);
        }
        if (code === -1) {
          apifield(message);
        }
      }
    },
  });

  useEffect(() => {
    if (user?.manNo) {
      mutation.mutate(user.manNo);
    }
  }, [user?.manNo]);

  useEffect(() => {
    if (isSuccess && user?.manNo) {
      mutation.mutate(user.manNo);
    }
  }, [isSuccess]);

  return {
    manInf: manInfRef.current,
  };
};

// 매니저 정보 수정
export const useUpdate = () => {
  const onSetAlert = useAlertStore((state) => state.onSetAlert);
  const { setIsSuccess } = useManagerDetailContext();
  return useMutation({
    mutationKey: ["member-manager-update"],
    mutationFn: manInfModifyApi,
    onSuccess: (res) => {
      if (res) {
        const {
          status: { code, message },
        } = res;
        if (code === 0) {
          //
          onSetAlert({
            isOpen: true,
            inner: "매니저 정보를 수정완료하였습니다.",
            onSetConfirm: () => {
              // 매니저 상세 재 조회
              setIsSuccess(true);
            },
          });
        }
        if (code === -1) {
          apifield(message);
        }
      }
    },
  });
};
